export default __webpack_public_path__ + "static/media/circle.5a762be6.png";